<template>
  <SiteHeader />
  <SiteBlobBanner
    title="Mentions légales"
  />
  <Suspense>
    <SiteLegal />
  </Suspense>
  <SiteFooter />
  <SitePostFooter />
</template>

<script setup>
  import SiteHeader from '@/sections/SiteHeader'
  import SiteLegal from '@/sections/legal'
  import SiteBlobBanner from '@/sections/SiteBlobBanner'
  import SiteFooter from '@/sections/SiteFooter'
  import SitePostFooter from '@/sections/SitePostFooter'

  const { setSeoMeta } = useSeo()
  
  setSeoMeta({
    title: 'Mentions Légales - CRA Freelance',
    description: 'Mentions légales de CRA Freelance, plateforme de gestion des CRA pour freelances en régie. Informations sur l\'éditeur, l\'hébergement et les conditions d\'utilisation.',
    type: 'website',
    keywords: ['mentions légales', 'conditions d\'utilisation', 'freelance en régie', 'CRA', 'facturation']
  })

  definePageMeta({
    name: 'legal'
  })
</script>